import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import Radio from "components/radio";

interface IProps {
  Price?: number;
  SetPrice: (value: number) => void;
}
const TrackPrice = ({ Price, SetPrice }: IProps) => {
  const [price, setPrice] = useState(Price || 0.69);

  useEffect(() => {
    SetPrice(price);
  }, [price]);
  return (
    <GrayCard title="Track Price " subtitle=" (iTunes & Amazon)">
      <Typography color={Colors.grey500}>
        How much would you like to charge for each track?
      </Typography>
      <RadioItems>
        <RadioItem>
          <Radio value={price === 0.69} onClick={() => setPrice(0.69)} />
          <Typography ml="0.4" color={Colors.white200}>
            $0.69
          </Typography>
        </RadioItem>
        <RadioItem>
          <Radio value={price === 0.99} onClick={() => setPrice(0.99)} />
          <Typography ml="0.4" color={Colors.white200}>
            $0.99
          </Typography>
        </RadioItem>
        <RadioItem>
          <Radio value={price === 0.129} onClick={() => setPrice(0.129)} />
          <Typography ml="0.4" color={Colors.white200}>
            $0.129
          </Typography>
        </RadioItem>
      </RadioItems>
    </GrayCard>
  );
};

export default TrackPrice;

const RadioItems = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.6rem;
`;

const RadioItem = styled.div`
  display: flex;
  align-items: center;

  margin-right: 2.4rem;
`;
